import React from 'react';
import { Dialog } from 'primereact/dialog';
import AddNewStudentsCourse from './components/add-new-students.course';
import { CourseMetadataType } from '../../../../../api/types/programs/course/course-metadata.type';

interface AddStudentsToCourseDialogProps {
  visible: boolean;
  onHide: () => void;
  courseMetadata?: CourseMetadataType;
  closeDialog: () => void;
}

const AddStudentsToCourseDialog: React.FC<AddStudentsToCourseDialogProps> = ({
  visible,
  onHide,
  courseMetadata,
  closeDialog,
}) => {
  return (
    <Dialog
      header="הוספת סטודנטים"
      visible={visible}
      style={{
        height: '80vh',
        width: '90wh',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={onHide}
    >
      <AddNewStudentsCourse
        courseMetadata={courseMetadata}
        closeDialog={closeDialog}
      />
    </Dialog>
  );
};

export default AddStudentsToCourseDialog;
